import { render, staticRenderFns } from "./FloorPlanWithSamples.vue?vue&type=template&id=04f2c09e&scoped=true&"
import script from "./FloorPlanWithSamples.vue?vue&type=script&lang=js&"
export * from "./FloorPlanWithSamples.vue?vue&type=script&lang=js&"
import style0 from "./FloorPlanWithSamples.vue?vue&type=style&index=0&id=04f2c09e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f2c09e",
  null
  
)

export default component.exports